<template lang="pug">
  .component-send-to-external-service

    reveal(:confirm="true", @confirm="sendToSDI")
      h2 Sei sicuro?
      .status(v-if="invoice.extra.hasOwnProperty('einvoice')")
        h2 Ultimi status
        .results(v-for="result in invoice.extra.einvoice.results")
          div File name: {{result.uploadFileName}}
          div Result: {{result.errorCode}} - {{result.errorDescription}}
          div Date: {{result.created_at}}

      button.button(slot="trigger") Invia a SDI
</template>

<script>
  import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
  import MaggieHelper from '../../../../maggieHelper'
  import Reveal from '../../../structure/ui/Reveal'

  export default {
    name: 'SendToExternal',
    components: {Reveal},
    methods: {
      sendToSDI() {
        KeplerBackofficeSdk.invoices.select(this.invoice).sendToSdi((data) => {
          MaggieHelper.notification('upload-status', data)
        })
      },
    },
    props: ['invoice']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SendToExternalService.vue?95e60e94